import VueI18n from "vue-i18n";
import Vue from "vue";
import translations from "@/i18n/messages";

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'rs',
    messages: translations,
});

